import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ClientDetailService {
  clientDetail!:any;
  highSeverityLock = false;
  private readonly clientInfoSubject = new BehaviorSubject<any>(null);
  readonly clientInfoChanges = this.clientInfoSubject.asObservable();
  constructor() { }

  /**
   * set Client Object
   * @param- clientObj
   */
  public setClientInfo(clientObj: any) {
    this.clientDetail = clientObj;
    this.syncHighSeverityLock();
    this.clientInfoSubject.next(clientObj);
  }

  /**
   * Apply an active high-severity alert from either clients/detail or client_data.
   * A payload with no alerts array leaves the current lock unchanged.
   */
  private syncHighSeverityLock(): void {
    const source = this.clientDetail?.alerts;
    if (!Array.isArray(source)) {
      return;
    }
    const locked = source.some((alert: any) =>
      String(alert?.status || 'ACTIVE').toUpperCase() === 'ACTIVE' &&
      String(alert?.severity || '').toUpperCase() === 'HIGH'
    );
    this.highSeverityLock = locked;
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('lendisoft-high-alert-lock', locked);
    }
  }


  /**
   * get client info
   * @param- field
   * @returns- {string}
   */
  getClientInfo(field: string = ''):string | any {
    //  client detail
    const data =  this.clientDetail ? this.clientDetail[field] : '';
    return data;
  }


  /**
   * get Favicon
   * @returns- {string}
   */
  public get FAVICON(): string {
    const data = this.clientDetail ? this.clientDetail['favicon_temp_url'] : '';
    return data ? data : '';
  }

  /**
   * get Logo Light
   * @returns- {string}
   */
   public get LOGO_LIGHT(): string {
    const data = this.clientDetail ? this.clientDetail['logo_light_temp_url'] : '';
    return data ? data : '';
  }
  /**
   * get Logo Dark
   * @returns- {string}

   */
   public get LOGO_DARK(): string {
    const data = this.clientDetail ? this.clientDetail['logo_dark_temp_url'] : '';
    return data ? data : '';
  }

  /**
   * get Title
   * @returns- {string}
   */
   public get TITLE(): string {
    const data = this.clientDetail ? this.clientDetail['name'] : '';
    return data ? data : '';
  }

   /**
   * get client ID
   * @returns- {string}
   */
    public get CLIENT_ID(): string {
      const data = this.clientDetail ? this.clientDetail['slug']:'';
      return data ? data : '';
    }

    public hasActiveHighAlert(): boolean {
      if (this.highSeverityLock) {
        return true;
      }
      const source = this.clientDetail?.alerts;
      if (!Array.isArray(source)) {
        return false;
      }
      return source.some((alert: any) =>
        String(alert?.status || 'ACTIVE').toUpperCase() === 'ACTIVE' &&
        String(alert?.severity || '').toUpperCase() === 'HIGH'
      );
    }

   /**
   * get is default?
   * @returns- {string}
   */
    public get IS_DEFAULT(): string {
      const data = this.clientDetail ? this.clientDetail['is_default'] : '';
      return data;
    }

    public CLIENT_LOGO( theme: string= 'light' ): string {
      const data = this.clientDetail ? this.clientDetail[`logo_${theme}`] : '';
      return data ? data : '';
    }

}
